import React from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

import type { FlowComponentRenderProps, NotesComponentConfig } from '../types';
import HtmlText from './HtmlText';

const NotesBlock: React.FC<FlowComponentRenderProps<NotesComponentConfig>> = ({ config }) => {
  return (
    <Card
      sx={{
        bgcolor: 'var(--cx-brand-button-bg)',
        border: '1px solid',
        borderColor: 'var(--cx-brand-text)',
        borderRadius: 0.75,
        boxShadow: 'none',
        color: 'var(--cx-brand-text)',
        mt: 1.5,
        px: 1.5,
        pb: 1.5,
        pt: 1.5,
        overflow: 'visible',
        position: 'relative',
        '[data-cx-color-scheme="dark"] &': {
          background: 'transparent',
          border: 0,
          borderBottom: '1px solid var(--cx-brand-border)',
          borderRadius: 0,
          pl: 6,
          pr: 0,
          py: 2,
        },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: 'color-mix(in srgb, var(--cx-brand-primary) 12%, transparent)',
          borderRadius: 999,
          color: 'var(--cx-brand-primary)',
          display: 'none',
          height: 36,
          justifyContent: 'center',
          left: 0,
          position: 'absolute',
          top: 16,
          width: 36,
          '[data-cx-color-scheme="dark"] &': { display: 'flex' },
        }}
      >
        <ShieldOutlinedIcon sx={{ fontSize: 19 }} />
      </Box>
      <Box
        sx={{
          bgcolor: 'var(--cx-brand-text)',
          borderRadius: 0.5,
          color: 'var(--cx-brand-surface)',
          left: 1.5,
          maxWidth: 'calc(100% - 24px)',
          px: 0.75,
          py: 0.25,
          position: 'absolute',
          top: -12,
          zIndex: 1,
          '[data-cx-color-scheme="dark"] &': {
            background: 'transparent',
            color: 'var(--cx-brand-text)',
            left: 48,
            p: 0,
            position: 'absolute',
            top: 14,
          },
        }}
      >
        <HtmlText
          component="div"
          html={config.title ?? 'Service notes'}
          variant="caption"
          sx={{ fontSize: 12, lineHeight: '20px' }}
        />
      </Box>
      <HtmlText
        component="div"
        html={config.body}
        variant="body2"
        sx={{
          color: 'var(--cx-brand-text)',
          fontSize: 14,
          lineHeight: '22px',
          '[data-cx-color-scheme="dark"] &': {
            color: 'var(--cx-brand-text-muted)',
            pt: 2.5,
          },
        }}
      />
    </Card>
  );
};

export default NotesBlock;
